export const getCurrencySymbol = (currencyCode: string) => {
  return (0)
    .toLocaleString('en', {
      style: 'currency',
      currency: currencyCode,
    })
    .replace(/\d/g, '')
    .trim();
};
